const CampaignTypes = {
  CAMPAIGN: 'CAMPAIGN',
  REVIEW: 'REVIEW',
  POSTER: 'POSTER',
}

export default CampaignTypes
